export const THEME_TYPES = {
    THEME_DARK : "dark",
    THEME_LIGHT : "light"
};